export enum RumorCompleteness {
  VAGUE = 'VAGUE',
  PARTIAL = 'PARTIAL',
  COMPLETE = 'COMPLETE',
}
